import { render, staticRenderFns } from "./player-view-profile-teams.vue?vue&type=template&id=50c5e7a5&"
import script from "./player-view-profile-teams.vue?vue&type=script&lang=js&"
export * from "./player-view-profile-teams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports